module.exports = __webpack_public_path__ + "img/neck-endomorph-male.0cc23e6c.svg";